import ReactDOM from 'react-dom/client';
import { App } from '~/App';
import '~/assets/styles/onest.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
